import {render} from 'react-dom';
import App from './App/App';
import React from 'react';

const rootElement = document.getElementById('root');
render(
    <App />, 
    rootElement
);
